export default {
  label: '采矿总工程师',
  id: '0',
  children: [
    {
      label: '岗位定义',
      id: '0-1',
      children: [
        {
          label: '矿山总工程师负责矿山整体技术工作，包括矿区整体开采规划和技术管理',
          id: '0-1-1',
        }
      ],
    },
    {
      label: '岗位职责',
      id: '0-2',
      children: [
        {
          label: '协助总工程师做好矿区整体开采规划，保持剥采平衡',
          id: '0-2-1',
        },
        {
          label: '审查矿山开发利用方案，监督采矿施工合同的执行',
          id: '0-2-2'
        },
        {
          label: '负责矿山安全生产监督和环境保护措施的落实',
          id: '0-2-3'
        }
      ],
    },
    {
      label: '技能要求',
      id: '0-3',
      children: [
        {
          label: '拥有丰富的矿山工程经验，熟悉矿山开采技术和安全管理',
          id: '0-3-1',
        },
        {
          label: '具备较强的组织协调能力和决策能力',
          id: '0-3-2',
        }
      ]
    }
  ]
};